/**
 *  ==========================
 *  BLOCK: Icon Block
 *  ==========================
 */

/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n'
import {
	disabledBlocks, i18n, srcUrl
} from 'cartzillagb'
import DefaultImage  from  './img/img1.png'

/**
 * Internal dependencies
 */
import edit from './edit'
import save from './save'
import { PricingBoxIcon } from '~cartzillagb/icons'
import { createButtonAttributes } from '~cartzillagb/util'

export const schema = {
	badge: {
		type: 'string',
	},
	pretitle: {
		type: 'string'
	},
	title: {
		type: 'string'
	},
	subtitle: {
		type: 'string'
	},
	enableBadge: {
		type: 'boolean',
		default: true,
	},
	enablePretitle: {
		type: 'boolean',
		default: true,
	},
	enableTitle: {
		type: 'boolean',
		default: true,
	},
	enableSubtitle: {
		type: 'boolean',
		default: true,
	},
	enableButton: {
		type: 'boolean',
		default: true,
	},
	mediaURL: {
		type: 'string',
		default: `${ srcUrl }/${ DefaultImage }`
	},
	enableTimer: {
		type: 'boolean',
		default: true,
	},
	bgcolor: {
		type: 'string'
	},
	custombgcolor: {
		type: 'string'
	},
	badgecolor: {
		type: 'string'
	},
	custombadgecolor: {
		type: 'string'
	},

	daysLabel: {
        type: 'string',
        default: __( 'd', i18n ),
    },
    hoursLabel: {
        type: 'string',
        default: __( 'h', i18n ),
    },
    minsLabel: {
        type: 'string',
        default: __( 'm', i18n ),
    },
    secsLabel: {
        type: 'string',
        default: __( 's', i18n ),
    },

	...createButtonAttributes( 'button1%s', {
        defaultText: 'View Offer',
        iconAfterText: true,
        backgroundColor: 'accent',
        defaultIcon: 'czi-arrow-right',
    } ),

	date: {
        type: 'string',
        default: new Date('07/01/2021 07:00:00 PM'),
    },
}

export const name = 'czgb/deals-block'

export const settings = {
	title: __( 'Deal Banner', i18n ),
	description: __( 'Capture your audience attention with a deal banner that has a countdown timer.', i18n ),
	icon: PricingBoxIcon,
	category: 'cartzillagb',
	example: {},
	keywords: [
        __( 'Deal Banner', i18n ),
        __( 'Countdown Timer', i18n ),
		__( 'deals-block', i18n ),
		__( 'CartzillaGB', i18n ),
	],
	attributes: schema,
	supports: {
		inserter: ! disabledBlocks.includes( name ), // Hide if disabled.
	},

	edit,
	save,

	// CartzillaGB modules.
	modules: {
		'advanced-responsive': true,
	},
}
